import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { createEpicMiddleware } from "redux-observable";

import reducers from "./reducers";
import epics from "./epics";

const composeEnhancers = composeWithDevTools({});
const epicMiddleware = createEpicMiddleware(epics);

export default createStore(
  reducers,
  composeEnhancers(applyMiddleware(epicMiddleware))
);



// WEBPACK FOOTER //
// ./src/store.js